import colors from 'basic-ui-lib/constants/colors';
import { IContentItem } from 'modules/channel/interfaces/api';
import { TypeMedia } from 'modules/channel/services/constants';
import styled from 'styled-components';

interface MainZoneProps {
  value?: IContentItem[];
  activeZone?: string;
  onSelectZone?: (zone: string) => void;
  border?: number;
}
export const renderMedia = (item?: IContentItem, border?: number) => {
  if (!item?.url) return null;

  const style: React.CSSProperties = {
    width: '100%',
    height: '100%',
    position: 'absolute',
    top: 0,
    left: 0,
    objectFit: 'cover',
    borderRadius: border ? `${border}px` : '1px',
  };

  if (item.type === TypeMedia.VIDEO) {
    return <video src={item.url} style={style} autoPlay loop muted />;
  }

  return <img src={item.url} style={style} alt={item.zone} />;
};

const MainZone = ({ value, onSelectZone, activeZone, border }: MainZoneProps) => {
  const isActive = activeZone === 'MAIN';
  const zoneValue = value?.find((item) => item.zone === 'MAIN');

  return (
    <MainZoneWrapper $border={border} $active={isActive} onClick={() => onSelectZone?.('MAIN')}>
      {renderMedia(zoneValue, border)}
    </MainZoneWrapper>
  );
};

export default MainZone;

const MainZoneWrapper = styled.div<{ $border?: number; $active?: boolean }>`
  width: 100%;
  height: 100%;
  min-width: 48px;

  border-radius: ${({ $border }) => ($border ? `${$border}px` : '1px')};
  background-color: ${colors.neutral.text[3]};
  border: ${({ $active }) => ($active ? `2px solid ${colors.primary[3]}` : '2px solid transparent')};

  overflow: hidden; /* quan trọng */
  position: relative; /* cho ảnh tuyệt đối nếu cần */
`;
